import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import PricingStatusCard from './PricingStatusCard';
import { useAdminTheme } from '../../contexts/AdminThemeContext';

const PricingStatusModal = ({ isOpen, onClose }) => {
  const { isDarkMode } = useAdminTheme();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />
        
        {/* Modal */}
        <div className={`relative rounded-lg shadow-xl max-w-md w-full mx-auto transition-colors duration-300 ${
          isDarkMode ? 'bg-skyone-card-dark' : 'bg-white'
        }`}>
          {/* Header */}
          <div className={`flex items-center justify-between p-6 border-b transition-colors duration-300 ${
            isDarkMode ? 'border-skyone-border-dark' : 'border-gray-200'
          }`}>
            <h2 className={`text-xl font-semibold transition-colors duration-300 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>Pricing Status</h2>
            <button
              onClick={onClose}
              className={`transition-colors duration-300 ${
                isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          
          {/* Content */}
          <div className="p-6">
            <PricingStatusCard isDarkMode={isDarkMode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingStatusModal;
